import { Site } from 'shared/hooks';
import { HqApiService } from 'hq/services/hqApiService';
import { OgpApiService } from 'ogp/services/ogp-api-service';
import { FlexPool } from 'hq/services/flex-pool-service.types';
import { flexPoolsSchema } from './schema/flex-pool.schema';

export class FlexPoolService {
  constructor(
    private readonly ogpApiService: OgpApiService,
    private readonly hqApiService: HqApiService
  ) {}

  public async getFlexPoolsForFlexWorker(site: Site, flexWorkerId: string) {
    const response = await this.getFlexPoolsForFlexWorkerImpl(site, flexWorkerId);
    return flexPoolsSchema.parse(response);
  }

  public async getFlexPoolsForFlexWorkerImpl(site: Site, flexWorkerId: string) {
    const path = `flex-pools/for-flexworker/${flexWorkerId}`;
    if (site === 'hq') {
      return await this.hqApiService.get<FlexPool[]>({
        path,
      });
    } else if (site === 'ogp') {
      return await this.ogpApiService.get<FlexPool[]>({
        path,
      });
    }

    throw new Error('Not yet implemented');
  }
}
